import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import { Duration } from '../../types/duration.type';
import {
  CoachingSectionType,
  MinMaxStep,
  WorkoutSectionDataByMode,
} from '../../types/section.type';

export const DEFAULT_SECTION_DURATION: Duration = {
  minutes: 0,
  seconds: 10,
};

export const DEFAULT_WORKOUT_SECTION_DATA: {
  readonly [M in WorkoutMode]: Readonly<WorkoutSectionDataByMode[M]>;
} = {
  ftp: { ftp: 50 },
  watts: { watts: 100 },
  res: { resistance: 50 },
  slope: { slope: 2 },
  inc: { incline: 5 },
  spd: { speed: 5 },
  incSpd: { incline: 5, speed: 5 },
};

/** Duree minimale d'une section, en secondes. */
export const MIN_SECTION_DURATION_SECONDS: number = 10;

export const DEFAULT_COACHING_SECTION_DURATION_SECONDS: number = 60;

export const DEFAULT_COACHING_SECTION_DATA: Readonly<CoachingSectionType> = {
  cadence: 50,
  resistance: 50,
};

/** Cadence donnee a une section quand on lui en ajoute une, en %. */
export const DEFAULT_SECTION_CADENCE: number = 50;

/** Bornes et pas de la cadence d'une section, en %. */
export const SECTION_CADENCE_MIN_MAX_STEP: Readonly<MinMaxStep> = { min: 1, max: 100, step: 1 };
